/**
 * Kısa yeniden deneme: SSR / Node’da backend geç açılınca ECONNREFUSED olur.
 * Tarayıcıda varsayılan tek deneme (gereksiz gecikme yok).
 */
export async function fetchWithConnectionRetry(
  input: RequestInfo | URL,
  init?: RequestInit,
  options?: { attempts?: number; baseDelayMs?: number },
): Promise<Response> {
  const defaultAttempts = typeof window === 'undefined' ? 4 : 1
  const attempts = options?.attempts ?? defaultAttempts
  const baseDelayMs = options?.baseDelayMs ?? 300
  let lastError: unknown
  for (let i = 0; i < attempts; i++) {
    try {
      return await fetch(input, init)
    } catch (e) {
      lastError = e
      if (i === attempts - 1) break
      await new Promise((r) => setTimeout(r, baseDelayMs * (i + 1)))
    }
  }
  throw lastError
}
